import React, { useState } from "react";
import {
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import FormButtons from "../../common/register/FormButtons";
import { Form, Formik } from "formik";
import InputField from "../../common/InputField";
import * as Yup from "yup";
import { register } from "../../services/user/UserServices";
import { toast, Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const UserFrom = (props) => {
  const { t } = useTranslation();
  const { next, setAuthToken } = props;
  const navigate = useNavigate();
  const [dateError, setDateError] = useState("");
  const validate = Yup.object({
    FirstName: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters")),
    LastName: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters")),
    Email: Yup.string()
      .matches(
        // eslint-disable-next-line
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        t("Must-be-ValidEmail")
      )
      .required(t("required")),
    DOB: Yup.string()
      .required(t("required"))
      .test("DATE", t("choose-between 1930-current-date"), (value) => {
        if (value) {
          let [yyyy, mm, dd] = value?.split("-");
          let currentDate = new Date(Date.now()).toLocaleDateString("en-GB");
          let [curDay, curMonth, curYear] = currentDate.split("/");
          return 1930 <= yyyy && curYear >= yyyy;
        }
      }),
    Street: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters"))
      .matches(/^[a-zA-Z-.äöüÄÖÜß ]*$/g, t("validation-p1")),
    Gender: Yup.string().required(t("required")).nullable(),
    HouseNumber: Yup.string()
      .required(t("required"))
      .max(10, t("max-10-digits")),
    City: Yup.string().required(t("required")).max(50, t("max-50-characters")),
    PostCode: Yup.number()
      .required(t("required"))
      .positive(t("postalCode-positive"))
      .test(
        "len",
        t("max-5-characters"),
        (val) => !val || (val && val.toString().length === 5)
      ),
    PhoneNumber: Yup.number(t("must-be-number"))
      .min(0, t("must-be-positive"))
      .typeError("Phone number must be a number")
      .test(
        "len",
        t("less-than-15"),
        (val) => !val || (val && val.toString().length <= 15)
      ),
  });

  const handleSubmit = async (formik) => {
    let date = formik.DOB?.split("-");
    if (date[0].length > 4) {
      setDateError("Date must be valid!");
    } else {
      let formData = new FormData();
      Object.keys(formik).map((key) => {
        return formData.append(`${key}`, formik[key]);
      });

      let result = await register(formData);
      if (result?.success) {
        setAuthToken(result?.payLoad?.token);
        next();
      } else {
        toast.error(result?.message);
      }
    }
  };
  return (
    <>
      <Toaster />
      <Typography variant="h4" fontWeight="bold" color="color.magentaDark1">
        {t("user-data")}
      </Typography>
      <Formik
        initialValues={{
          FirstName: "",
          LastName: "",
          Email: "",
          DOB: new Date().toISOString().slice(0, 10),
          Street: "",
          Gender: "",
          HouseNumber: "",
          City: "",
          PostCode: 0,
          PhoneNumber: 0,
        }}
        enableReinitialize
        validationSchema={validate}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <Form
            onChange={() => {
              setDateError("");
            }}
          >
            <InputField
              fullWidth
              variant="standard"
              placeholder="John"
              label={t("input-1")}
              name="FirstName"
              type="text"
            />
            <InputField
              fullWidth
              variant="standard"
              placeholder="Doe"
              label={t("input-10")}
              name="LastName"
              type="text"
            />

            <InputField
              fullWidth
              variant="standard"
              label={t("input-2")}
              name="DOB"
              type="date"
            />
            {dateError && (
              <p style={{ margin: 0, fontSize: "12px", color: "red" }}>
                {dateError}
              </p>
            )}
            <FormControl variant="standard" margin="dense" fullWidth>
              <InputLabel id="demo-simple-select-standard-label">
                {t("input-21")}
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                name="Gender"
                onChange={(event) => {
                  formik.setFieldValue("Gender", event.target.value);
                }}
                label={t("Age")}
              >
                <MenuItem value={"male"}>{t("male")}</MenuItem>
                <MenuItem value={"female"}>{t("female")}</MenuItem>
                <MenuItem value={"other"}>{t("rm-type-7")}</MenuItem>
              </Select>
              <p style={{ margin: 0, fontSize: "12px", color: "red" }}>
                {formik.errors.Gender}
              </p>
            </FormControl>
            <Grid container spacing={2}>
              <Grid item lg={7} md={6} xs={12}>
                <InputField
                  fullWidth
                  variant="standard"
                  placeholder={t("street-plaeholder")}
                  label={t("input-6")}
                  name="Street"
                  type="text"
                />
              </Grid>
              <Grid item lg={5} md={6} xs={12}>
                <InputField
                  fullWidth
                  variant="standard"
                  placeholder="40023"
                  label={t("input-7")}
                  name="HouseNumber"
                  type="text"
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item lg={7} md={6} xs={12}>
                <InputField
                  fullWidth
                  variant="standard"
                  placeholder="New york"
                  label={t("input-8")}
                  name="City"
                  type="text"
                />
              </Grid>
              <Grid item lg={5} md={6} xs={12}>
                <InputField
                  fullWidth
                  variant="standard"
                  label={t("input-22")}
                  name="PostCode"
                  type="number"
                />
              </Grid>
            </Grid>
            <InputField
              fullWidth
              variant="standard"
              placeholder="demo@gmail.com"
              label={t("input-3")}
              name="Email"
              type="email"
            />
            <InputField
              fullWidth
              variant="standard"
              placeholder="2842394789"
              label={t("input-4")}
              name="PhoneNumber"
              type="string"
            />
            <FormButtons
              back={() => {
                navigate("/");
              }}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default UserFrom;
